import React from "react";

import { GenericExternalLink } from "@components/generic-external-link";
import { NorthbeamUtmPlatform } from "@features/utm-guide";

import { CopyUtmParams } from "../copy-utm-params";

export const Outbrain = () => (
  <div className="flex flex-col gap-3">
    <p className="mb-0">
      You will need to add UTM parameters to all existing campaigns. To do so,
      navigate to each campaign&apos;s <b>settings</b> page, and going down to
      the <b>Track</b> section. If you need help finding this section, you can
      look at these{" "}
      <GenericExternalLink href="https://www.outbrain.com/help/advertisers/utm-tracking/">
        instructions
      </GenericExternalLink>
      .
    </p>
    <CopyUtmParams className="mb=3" platform={NorthbeamUtmPlatform.OUTBRAIN} />
    <p className="mb-0">
      Copy the Northbeam UTM parameters text and paste it into the <b>Suffix</b>{" "}
      input field.
    </p>
  </div>
);
